<template>
  <img @click="onClick" :src="src" class="icon"/>
</template>

<script>
export default {
  name: 'app-icon',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    src() {
      const image = `https://cdn.parcelex.com.br/assets/v2/${this.name}-icon.svg`;
      return image;
    },
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
